/* CaseCrush - Two cascading dropdowns (Brand -> Model) driving the real
   Shopify "Phone Model" variant select underneath. The native select is
   kept in the DOM (hidden) so Dawn's variant-selects logic, cart form
   submission, pricing and availability all keep working unchanged.

   Dawn's product-info.js replaces the entire <variant-selects> markup
   with freshly fetched server HTML on every variant change (to keep
   price/availability/URL in sync) - that wipes our injected card, so we
   rebuild it every time Dawn's own PUB_SUB_EVENTS.variantChange fires,
   not just once on page load. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function buildTwoDropdown(wrapper) {
    if (wrapper.dataset.ccTwoDropdownInit) return;

    var nativeSelect = wrapper.querySelector('select.select__select');
    if (!nativeSelect) return;

    var options = Array.prototype.slice.call(nativeSelect.querySelectorAll('option[data-brand]'));
    if (!options.length) return;

    wrapper.dataset.ccTwoDropdownInit = 'true';

    var brands = [];
    var modelsByBrand = {};
    options.forEach(function (opt) {
      var brand = opt.getAttribute('data-brand');
      if (!brand) return;
      if (brands.indexOf(brand) === -1) {
        brands.push(brand);
        modelsByBrand[brand] = [];
      }
      modelsByBrand[brand].push({ value: opt.value, text: opt.textContent.trim(), disabled: opt.disabled });
    });
    if (brands.length < 2) return;

    var card = document.createElement('div');
    card.className = 'cc-phone-card';

    var header = document.createElement('div');
    header.className = 'cc-phone-card__header';
    header.innerHTML =
      '<span class="cc-phone-card__icon">\u{1F4F1}</span>' +
      '<span class="cc-phone-card__title">Find your perfect fit</span>';
    card.appendChild(header);

    var row = document.createElement('div');
    row.className = 'cc-phone-card__row';

    function makeField(labelText, iconGlyph) {
      var field = document.createElement('div');
      field.className = 'cc-phone-field';

      var label = document.createElement('label');
      label.className = 'cc-phone-field__label';
      label.innerHTML = '<span class="cc-phone-field__icon">' + iconGlyph + '</span>' + labelText;
      field.appendChild(label);

      var selectWrap = document.createElement('div');
      selectWrap.className = 'select cc-phone-field__select-wrap';
      var select = document.createElement('select');
      select.className = 'select__select cc-phone-field__select';
      selectWrap.appendChild(select);

      var caret = document.createElement('span');
      caret.className = 'cc-phone-field__caret';
      caret.innerHTML =
        '<svg viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      selectWrap.appendChild(caret);

      field.appendChild(selectWrap);
      return { field: field, select: select };
    }

    var brandField = makeField('Phone Brand', '\u{1F310}');
    var modelField = makeField('Phone Model', '\u{1F4F2}');
    modelField.field.classList.add('cc-phone-field--model');

    row.appendChild(brandField.field);
    row.appendChild(modelField.field);
    card.appendChild(row);

    var status = document.createElement('p');
    status.className = 'cc-phone-card__status';
    card.appendChild(status);

    var brandSelect = brandField.select;
    var modelSelect = modelField.select;

    var brandPlaceholder = document.createElement('option');
    brandPlaceholder.value = '';
    brandPlaceholder.textContent = 'Choose a brand';
    brandPlaceholder.disabled = true;
    brandSelect.appendChild(brandPlaceholder);
    brands.forEach(function (brand) {
      var opt = document.createElement('option');
      opt.value = brand;
      opt.textContent = brand;
      brandSelect.appendChild(opt);
    });

    var modelPlaceholderText = 'Choose a brand first';
    function freshModelPlaceholder() {
      var opt = document.createElement('option');
      opt.value = '';
      opt.textContent = modelPlaceholderText;
      opt.disabled = true;
      opt.selected = true;
      return opt;
    }
    modelSelect.appendChild(freshModelPlaceholder());
    modelSelect.disabled = true;

    var nativeFieldWrap = nativeSelect.closest('.select') || nativeSelect;
    nativeFieldWrap.classList.add('cc-native-select--hidden');
    nativeFieldWrap.parentNode.insertBefore(card, nativeFieldWrap);

    function updateStatus(text, ok) {
      status.textContent = text;
      status.classList.toggle('cc-phone-card__status--ok', !!ok);
    }

    function populateModels(brand, preselectValue) {
      modelPlaceholderText = 'Choose a model';
      modelSelect.innerHTML = '';
      modelSelect.appendChild(freshModelPlaceholder());
      var models = modelsByBrand[brand] || [];
      models.forEach(function (m) {
        var opt = document.createElement('option');
        opt.value = m.value;
        opt.textContent = m.text;
        if (m.disabled) opt.disabled = true;
        if (preselectValue && m.value === preselectValue) {
          opt.selected = true;
          modelSelect.querySelector('option[value=""]').selected = false;
        }
        modelSelect.appendChild(opt);
      });
      modelSelect.disabled = models.length === 0;
      if (!preselectValue) updateStatus('Now pick your exact model', false);
    }

    function setNativeValue(value) {
      nativeSelect.value = value;
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    brandSelect.addEventListener('change', function () {
      card.classList.remove('cc-phone-card--complete');
      populateModels(brandSelect.value, null);
    });

    modelSelect.addEventListener('change', function () {
      if (!modelSelect.value) return;
      setNativeValue(modelSelect.value);
      updateStatus('✓ ' + brandSelect.value + ' ' + modelSelect.options[modelSelect.selectedIndex].textContent + ' selected', true);
      card.classList.add('cc-phone-card--complete');
    });

    var selectedOption = nativeSelect.querySelector('option:checked') || options[0];
    if (selectedOption && selectedOption.value) {
      var selBrand = selectedOption.getAttribute('data-brand');
      if (selBrand) {
        brandSelect.value = selBrand;
        populateModels(selBrand, selectedOption.value);
        updateStatus('✓ ' + selBrand + ' ' + selectedOption.textContent.trim() + ' selected', true);
        card.classList.add('cc-phone-card--complete');
      }
    } else {
      updateStatus('Pick your phone brand to get started', false);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-phone-model-picker]').forEach(buildTwoDropdown);
  }

  ready(initAll);
  document.addEventListener('shopify:section:load', initAll);

  // Dawn's product-info.js replaces <variant-selects> innerHTML (wiping our
  // card) on every variant change, then publishes this event once it's
  // done updating price/availability/URL - rebuild right after.
  ready(function () {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(initAll, 0);
      });
    }
  });
})();
